import SkuSearchRepository from './Repository/sku-search-repository'
import React, { Fragment, useEffect, useState,useMemo } from "react"
import PropTypes from 'prop-types';
import {
    Container,
    Button,
    Card,
    CardBody,
    Row,
    Col,
    BreadcrumbItem,
    Input,
    Form,
    FormGroup,
    Label,
    Alert
} from "reactstrap"
import { Link } from 'react-router-dom'
import LoadingContainer from "../Utility/Helpers/LoadingContainer"
import SkuProjectsTable from "./Widget/SkuProjectsTable"
import {DIALOG_TYPE, HTTP_RESPONSE} from "../Utility/Helpers/constants"
import DialogBoxComponent from "../Utility/Helpers/DialogBoxComponent"
import "../Utility/Helpers/style.css"
import SkuRepository from "./Repository/sku-repository"
import AuthorizationChecker from "../../security/AuthorizationChecker"
import { withTranslation, useTranslation } from "react-i18next"
import UserProvier from "security/UserProvier"

const SearchSkuCode = () => {
  const { t } = useTranslation()
  const [sku, setSku] = useState('')
  const [result, setResult] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  const companyId = UserProvier.get().companyId
  const handleSearch = async (e) => {
    e.preventDefault()
    setLoading(true)
    setError('')
    setResult(null)
    try {
      const data = await SkuSearchRepository.searchSku(sku, companyId)
      console.log(data)
      setResult(data)
    } catch (err) {
      setError(t('ERROR_OCCURRED') || 'Erreur lors de la recherche')
    } finally {
      setLoading(false)
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <LoadingContainer loading={loading}>
            <Card>
              <CardBody>
                <div className="mb-4">
                  <Row>
                    <Col xs="12">
                      <div className="page-title-box justify-content-between">
                        <div className="">
                          <ol className="breadcrumb m-0">
                            <BreadcrumbItem>.</BreadcrumbItem>
                            <BreadcrumbItem>
                              <Link to="#">{t('SEARCH')} </Link>
                            </BreadcrumbItem>
                          </ol>
                        </div>
                      </div>
                    </Col>
                  </Row>

                  <Row className="mb-4">
                    <Col lg="6">
                      <Form onSubmit={handleSearch}>
                        <FormGroup className="mb-3">
                          <Label htmlFor="sku-input">{t('ENTER_CODE')} </Label>
                          <div className="d-flex gap-2">
                            <Input
                              type="text"
                              id="sku-input"
                              className="form-control"
                              value={sku}
                              onChange={e => setSku(e.target.value)}
                              placeholder={t('ENTER_CODE') + ' ...'}
                              required
                            />
                            <Button 
                              type="submit" 
                              color="primary" 
                              disabled={loading}
                            >
                              {loading ? t('LOADING') || 'Recherche...' : t('SEARCH')}
                            </Button>
                          </div>
                        </FormGroup>
                      </Form>
                    </Col>
                  </Row>

                  {error && (
                    <Row className="mb-3">
                      <Col lg="12">
                        <Alert color="danger">{error}</Alert>
                      </Col>
                    </Row>
                  )}

                  {result && result.status === 'free' && result.message === 'SKU_NOT_FOUND' && (
                    <Row className="mb-3">
                      <Col lg="12">
                        <Alert color="success">
                          <i className="mdi mdi-check-circle me-2"></i>
                          <strong>{t('SKU_FREE_FOR_USE') || 'Ce code  est libre et peut être utilisé.'}</strong>
                        </Alert>
                      </Col>
                    </Row>
                  )}

                  {result && result.status === 'used' && result.message === 'SKU_USED_NO_PROJECT' && result.projets && result.projets.length === 0 && (
                    <Row className="mb-3">
                      <Col lg="12">
                        <Alert color="danger">
                          <i className="mdi mdi-check-circle me-2"></i>
                          <strong>{t('SKU_USED_NO_PROJECT') || 'Ce code est utilisé mais n\'est pas associé à un projet.'}</strong>
                        </Alert>
                      </Col>
                    </Row>
                  )}

                  {result && result.projets && result.projets.length > 0 && (
                    <Row>
                      <Col lg="12">
                        <h5 className="mb-3">{t('RESULT_FOR', { sku }) || `${t('RESULT')} pour : ${sku}`}</h5>
                        <Alert color="danger">
                          <i className="mdi mdi-check-circle me-2"></i>
                          <strong>{t('SKU_USED_IN_PROJECTS') || 'Ce code est utilisé dans des projets.'}</strong>
                        </Alert>
                        <SkuProjectsTable projets={result.projets || []} />
                      </Col>
                    </Row>
                  )}
                </div>
              </CardBody>
            </Card>
          </LoadingContainer>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withTranslation()(SearchSkuCode)
